import request from '@/utils/request'
// 合作学者
export function searchCoreKeywordsv2(data) {
  return request({
    data: data,
    url: '/old/searchCoreKeywordsv2',
    method: 'post'
  })
}
export function searchCoreKeywordsv3(data) {
  return request({
    data: data,
    url: '/old/searchCoreKeywordsv3',
    method: 'post'
  })
}

export function expertSubject(data) {
  return request({
    data: data,
    url: '/old/expert/subject',
    method: 'post'
  })
}

export function expertKeyword(data) {
  return request({
    data: data,
    url: '/expert/keyword',
    method: 'post'
  })
}
export function keywordPair(data) {
  return request({
    data: data,
    url: '/expert/keywordPair',
    method: 'post'
  })
}
export function expertExcel(data) {
  return request({
    data: data,
    url: '/old/expert/excel',
    method: 'post'
  })
}

//   3a524389i9.qicp.vip:58080



// WEBPACK FOOTER //
// ./src/api/newsearch.js